<template>
  <div class="vx-row" id="printing_freight">
    <div class="vx-col lg:w-3/5 w-full" style="padding-right: 5px">
      <vx-card
        title="Payment Update"
        subtitle="Be sure your updating the payment delivered Product"
      >
        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full mb-2">
            <vs-input
              class="w-full"
              ref="lrgenerateText"
              label-placeholder="LR NO"
              v-model="currentLrNo"
              v-on:keyup.enter="getLrDetails"
              :disabled="loadingLrData"
            />
          </div>
          <div
            v-if="!fetchingLrDetails"
            class="vx-col md:w-1/3 sm:w-1/3 w-full"
            style="width: 23% !important"
          >
            <vs-button
              icon-pack="material-icons"
              icon="search"
              class="mt-4"
              @click="getLrDetails"
              >Search</vs-button
            >
          </div>
          <div
            v-if="fetchingLrDetails"
            class="vx-col md:w-1/3 sm:w-1/3 w-full"
            style="width: 23% !important"
          >
            Searching ....
          </div>
        </div>
      </vx-card>
    </div>

    <div class="vx-row" v-if="lrDataFound">
      <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
        <vx-card title="Basic Details" class="m-3">
          <div class="vx-row">
            <div class="vx-col flex-1/2" style="padding: 0">
              <table>
                <tr>
                  <td class="font-semibold">From</td>
                  <td>{{ lrDetails.consignmentFromBranchName }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Booking <br />Type</td>
                  <td>{{ lrDetails.consignmentBookingPaymentTypeName }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    Eway Bill <br />
                    No
                  </td>
                  <td>{{ lrDetails.consignmentEwayBillNo }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    Booked <br />
                    Date
                  </td>
                  <td>{{ lrDetails.consignmentBookedDate | date(true) }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    Freight <br />
                    Date
                  </td>
                  <td>
                    {{ lrDetails.consignmentFreightOn | date(true) }}
                  </td>
                </tr>
              </table>
            </div>
            <!-- /Information - Col 1 -->

            <!-- Information - Col 2 -->
            <div class="vx-col flex-1" style="padding: 0">
              <table>
                <tr style="vertical-align: baseline">
                  <td class="font-semibold" style="display: flex">
                    To &nbsp;<vs-button
                      class="xsm-icons-dg"
                      icon-pack="feather"
                      radius
                      icon="icon-edit-2"
                      @click="isShowToBranchControl = true"
                    ></vs-button>
                  </td>
                  <td v-if="!isShowToBranchControl">
                    {{ lrDetails.consignmentToBranchName }}
                  </td>
                  <td v-else-if="isShowToBranchControl">
                    <vs-select
                      autocomplete
                      name="toBranchId"
                      v-model="lrDetails.toBranchId"
                      icon="arrow_downward"
                      width="100%"
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.branchId"
                        :text="item.branchName"
                        v-for="(item, index) in toBranches"
                      />
                    </vs-select>
                  </td>
                </tr>

                <tr>
                  <td class="font-semibold">P.Invoice No</td>
                  <td>{{ lrDetails.consignmentProductInvoiceNo }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Product <br />Value</td>
                  <td>{{ lrDetails.consignmentProductValue }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    Booked <br />
                    By
                  </td>
                  <td>{{ lrDetails.consignmentCreatedUser }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">
                    Freight <br />
                    By
                  </td>
                  <td>{{ lrDetails.consignmentFrieghtAddedUser || "--" }}</td>
                </tr>
              </table>
            </div>
            <!-- Information - Col 2 -->
            <div class="vx-col flex-1" style="padding: 0">
              <table>
                <tr style="vertical-align: baseline">
                  <td class="font-semibold" style="display: flex">
                    C Branch &nbsp;<vs-button
                      class="xsm-icons-dg"
                      icon-pack="feather"
                      radius
                      icon="icon-edit-2"
                      @click="isShowCurrentBranchControl = true"
                    ></vs-button>
                  </td>
                  <td v-if="!isShowCurrentBranchControl">
                    {{ lrDetails.consignmentCurrentBranch }}
                  </td>
                  <td v-else-if="isShowCurrentBranchControl">
                    <vs-select
                      autocomplete
                      name="currentBranchId"
                      v-model="lrDetails.currentBranchId"
                      icon="arrow_downward"
                      width="100%"
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.branchId"
                        :text="item.branchName"
                        v-for="(item, index) in toBranches"
                      />
                    </vs-select>
                  </td>
                </tr>
                <tr>
                  <td style="display: flex" class="font-semibold">
                    Consignment Status
                    <vs-button
                      class="xsm-icons-dg"
                      icon-pack="feather"
                      radius
                      icon="icon-edit-2"
                      @click="isShowConsignmentStatusControl = true"
                    ></vs-button>
                  </td>
                  <td v-if="!isShowConsignmentStatusControl">
                    {{ lrDetails.consignmentStatusName }}
                  </td>
                  <td v-else-if="isShowConsignmentStatusControl">
                    <vs-select
                      autocomplete
                      name="consignmentStatus"
                      v-model="lrDetails.consignmentStatus"
                      icon="arrow_downward"
                      width="100%"
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.value"
                        :text="item.name"
                        v-for="(item, index) in consignmentStatusList"
                      />
                    </vs-select>
                  </td>
                </tr>
                <tr>
                  <td class="font-semibold">Payment Status</td>
                  <td>{{ lrDetails.consignmentPaymentStatusName }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Paid Through</td>
                  <td>{{ lrDetails.paymentPaidThroughText }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Payment RefNo</td>
                  <td>{{ lrDetails.paymentRefNo || "--" }}</td>
                </tr>
              </table>
            </div>
          </div>
        </vx-card>
        <div
          class="vx-row"
          v-if="
            isShowCurrentBranchControl ||
              isShowToBranchControl ||
              isShowConsignmentStatusControl
          "
          style="float: right"
        >
          <vs-button
            icon-pack="material-icons"
            class="mt-4"
            @click="updateDetails"
            >Update Details</vs-button
          >
        </div>
      </div>
      <div class="vx-col lg:w-1/2 w-full" style="padding: 0 1rem">
        <vx-card title="Package Details" class="m-3">
          <vs-table max-items="3" stripe pagination :data="lrDetails.packages">
            <template slot="thead">
              <vs-th></vs-th>
              <vs-th>S No</vs-th>
              <vs-th>Consignment Type</vs-th>
              <vs-th>Quantity</vs-th>
              <vs-th>Total Weight (Kgs)</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <div
                    v-if="
                      isShowEditConsignmentPackageDetails &&
                        data[indextr].consignmentPackageTypeId ==
                          editPackageDetails.consignmentPackageTypeId
                    "
                  >
                    <vs-button
                      icon-pack="material-icons"
                      class="mt-1"
                      @click="updateActivePackageDetails"
                      >Update</vs-button
                    >
                  </div>
                  <div class="profile-actions pointer-events-auto flex" v-else>
                    <vs-button
                      class="sm-icons-dg"
                      icon-pack="feather"
                      radius
                      icon="icon-edit-2"
                      @click="setConsignmentPackageDetails(indextr)"
                    ></vs-button>
                    <!-- <vs-button icon-pack="feather" radius icon="icon-settings" class="ml-2 lg:ml-4"></vs-button> -->
                  </div>
                </vs-td>
                <vs-td>{{ indextr + 1 }}</vs-td>
                <vs-td :data="data[indextr].consignmentPackageTypeName">
                  <div
                    v-if="
                      isShowEditConsignmentPackageDetails &&
                        data[indextr].consignmentPackageTypeId ==
                          editPackageDetails.consignmentPackageTypeId
                    "
                  >
                    <vs-select
                      autocomplete
                      name="consignmentPackageTypeId"
                      v-model="editPackageDetails.consignmentPackageTypeId"
                      icon="arrow_downward"
                      width="100%"
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.consignmentTypeId"
                        :text="item.consignmentTypeName"
                        v-for="(item, index) in consignementTypesList"
                      />
                    </vs-select>
                  </div>
                  <div v-else>
                    {{ data[indextr].consignmentPackageTypeName }}
                  </div></vs-td
                >
                <vs-td :data="data[indextr].consignmentPackageQuantity">
                  <div
                    v-if="
                      isShowEditConsignmentPackageDetails &&
                        data[indextr].consignmentPackageTypeId ==
                          editPackageDetails.consignmentPackageTypeId
                    "
                  >
                    <vs-input
                      class="w-full"
                      type="number"
                      name="consignmentPackageQuantity"
                      v-model.number="
                        editPackageDetails.consignmentPackageQuantity
                      "
                    />
                  </div>
                  <div v-else>
                    {{ data[indextr].consignmentPackageQuantity }}
                  </div></vs-td
                >
                <vs-td :data="data[indextr].consignmentPackageWeight"
                  ><div
                    v-if="
                      isShowEditConsignmentPackageDetails &&
                        data[indextr].consignmentPackageTypeId ==
                          editPackageDetails.consignmentPackageTypeId
                    "
                  >
                    <vs-input
                      class="w-full"
                      type="number"
                      name="consignmentPackageWeight"
                      v-model.number="
                        editPackageDetails.consignmentPackageWeight
                      "
                    />
                  </div>
                  <div v-else>
                    {{ data[indextr].consignmentPackageWeight }}
                  </div></vs-td
                >
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
      <div
        class="vx-row m-3"
        style="margin-bottom: 0.2rem !important; width: 100%"
      >
        <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
          <vx-card title="Consignor">
            <div
              class="vx-col flex-1 w-1/2"
              style="position: absolute; top: -1.7rem; left: 9.5rem"
            >
              <div class="profile-actions pointer-events-auto flex">
                <vs-button
                  class="sm-icons-dg"
                  icon-pack="feather"
                  radius
                  icon="icon-edit-2"
                  @click="isShowUpdateConsignorDetails = true"
                ></vs-button>
                <!-- <vs-button icon-pack="feather" radius icon="icon-settings" class="ml-2 lg:ml-4"></vs-button> -->
              </div>
            </div>
            <table>
              <tr>
                <td class="font-semibold">Name :</td>
                <td v-if="!isShowUpdateConsignorDetails">
                  {{ lrDetails.consignor.consignmentConsignorName }}
                </td>
                <td v-else-if="isShowUpdateConsignorDetails">
                  <vs-select
                    autocomplete
                    name="consignorId"
                    v-model="lrDetails.consignorId"
                    icon="arrow_downward"
                    width="100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.clientId"
                      :text="item.clientName"
                      v-for="(item, index) in clients"
                    />
                  </vs-select>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Mobile :</td>
                <td>
                  {{
                    lrDetails.consignor.consignmentConsignorMobileNo || " -- "
                  }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">GST No :</td>
                <td>
                  {{ lrDetails.consignor.consignmentConsignorGstNo || " -- " }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Address :</td>
                <td>
                  {{
                    lrDetails.consignor.consignmentConsignorAddress || " -- "
                  }}
                </td>
              </tr>
            </table>
          </vx-card>
          <div
            class="vx-row"
            v-if="isShowUpdateConsignorDetails"
            style="float: right"
          >
            <vs-button
              icon-pack="material-icons"
              class="mt-4"
              @click="updateConsignor"
              >Update Consignor</vs-button
            >
          </div>
        </div>
        <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
          <vx-card title="Consignee">
            <div
              class="vx-col flex-1 w-1/2"
              style="position: absolute; top: -1.7rem; left: 9.5rem"
            >
              <div class="profile-actions pointer-events-auto flex">
                <vs-button
                  class="sm-icons-dg"
                  icon-pack="feather"
                  radius
                  icon="icon-edit-2"
                  @click="isShowUpdateConsigneeDetails = true"
                ></vs-button>
                <!-- <vs-button icon-pack="feather" radius icon="icon-settings" class="ml-2 lg:ml-4"></vs-button> -->
              </div>
            </div>
            <table>
              <tr>
                <td class="font-semibold">Name :</td>
                <td v-if="!isShowUpdateConsigneeDetails">
                  {{ lrDetails.consignee.consignmentConsigneeName }}
                </td>
                <td v-else-if="isShowUpdateConsigneeDetails">
                  <vs-select
                    autocomplete
                    name="consigneeId"
                    v-model="lrDetails.consigneeId"
                    icon="arrow_downward"
                    width="100%"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.clientId"
                      :text="item.clientName"
                      v-for="(item, index) in clients"
                    />
                  </vs-select>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Mobile :</td>
                <td>
                  {{
                    lrDetails.consignee.consignmentConsigneeMobileNo || " -- "
                  }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">GST No:</td>
                <td>
                  {{ lrDetails.consignee.consignmentConsigneeGstNo || " -- " }}
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Address :</td>
                <td>
                  {{ lrDetails.consignee.consignmentConsigneeAddress || "--" }}
                </td>
              </tr>
            </table>
          </vx-card>
          <div
            class="vx-row"
            v-if="isShowUpdateConsigneeDetails"
            style="float: right"
          >
            <vs-button
              icon-pack="material-icons"
              class="mt-4"
              @click="updateConsignee"
              >Update Consignee</vs-button
            >
          </div>
        </div>
      </div>
      <div
        class="vx-row m-3"
        style="margin-bottom: 0.75rem !important; width: 100%"
      >
        <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
          <vx-card title="Payment Details">
            <div class="vx-row">
              <div
                class="vx-col flex-1 w-1/2"
                style="position: absolute; top: -1.7rem; left: 12.5rem"
              >
                <div class="profile-actions pointer-events-auto flex">
                  <vs-button
                    class="sm-icons-dg"
                    icon-pack="feather"
                    radius
                    icon="icon-edit-2"
                    @click="isShowPaymentControls = true"
                  ></vs-button>
                  <!-- <vs-button icon-pack="feather" radius icon="icon-settings" class="ml-2 lg:ml-4"></vs-button> -->
                </div>
              </div>
              <div class="vx-col flex-1 w-1/2">
                <table>
                  <tr>
                    <td class="font-semibold">Freight Charge</td>
                    <td v-if="!isShowPaymentControls">
                      {{ lrDetails.consignmentFreightCharge || 0 }}
                    </td>
                    <!-- placeholder="Freight Charge"
                      label-placeholder="Freight Change" -->
                    <td v-else-if="isShowPaymentControls">
                      <vs-input
                        class="w-full"
                        type="number"
                        name="consignmentFreightCharge"
                        v-model.number="lrDetails.consignmentFreightCharge"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Hamali Charge</td>
                    <td v-if="!isShowPaymentControls">
                      {{ lrDetails.consignmentHamaliCharge || 0 }}
                    </td>
                    <td v-else-if="isShowPaymentControls">
                      <vs-input
                        class="w-full"
                        type="number"
                        name="consignmentHamaliCharge"
                        v-model.number="lrDetails.consignmentHamaliCharge"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Stationary Charge</td>
                    <td v-if="!isShowPaymentControls">
                      {{ lrDetails.consignmentStationaryCharge || 0 }}
                    </td>
                    <td v-else-if="isShowPaymentControls">
                      <vs-input
                        class="w-full"
                        type="number"
                        name="consignmentStationaryCharge"
                        v-model.number="lrDetails.consignmentStationaryCharge"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Collection Charge</td>
                    <td v-if="!isShowPaymentControls">
                      {{ lrDetails.consignmentCollectionCharges || 0 }}
                    </td>
                    <td v-else-if="isShowPaymentControls">
                      <vs-input
                        class="w-full"
                        type="number"
                        name="consignmentCollectionCharges"
                        v-model.number="lrDetails.consignmentCollectionCharges"
                      />
                    </td>
                  </tr>
                </table>
              </div>
              <div class="vx-col flex-2 w-1/2">
                <table>
                  <tr>
                    <td class="font-semibold">DD Charge</td>
                    <td v-if="!isShowPaymentControls">
                      {{ lrDetails.consignmentDoorDeliveryCharge || 0 }}
                    </td>
                    <td v-else-if="isShowPaymentControls">
                      <vs-input
                        class="w-full"
                        type="number"
                        name="consignmentDoorDeliveryCharge"
                        v-model.number="lrDetails.consignmentDoorDeliveryCharge"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">LR Charge</td>
                    <td v-if="!isShowPaymentControls">
                      {{ lrDetails.consignmentLrCopyCharge || 0 }}
                    </td>
                    <td v-else-if="isShowPaymentControls">
                      <vs-input
                        class="w-full"
                        type="number"
                        name="consignmentLrCopyCharge"
                        v-model.number="lrDetails.consignmentLrCopyCharge"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">UnLoading Charge</td>
                    <td v-if="!isShowPaymentControls">
                      {{ lrDetails.consignmentUnloadingCharge || 0 }}
                    </td>
                    <td v-else-if="isShowPaymentControls">
                      <vs-input
                        class="w-full"
                        type="number"
                        name="consignmentUnloadingCharge"
                        v-model.number="lrDetails.consignmentUnloadingCharge"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Other Charge</td>
                    <td v-if="!isShowPaymentControls">
                      {{ lrDetails.consignmentOtherCharge || 0 }}
                    </td>
                    <td v-else-if="isShowPaymentControls">
                      <vs-input
                        class="w-full"
                        type="number"
                        name="consignmentOtherCharge"
                        v-model.number="lrDetails.consignmentOtherCharge"
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </vx-card>
          <div class="vx-row" v-if="isShowPaymentControls" style="float: right">
            Total Amount :{{ getTotalPayment }}
            <vs-button
              icon-pack="material-icons"
              class="mt-4"
              @click="updatePayment"
              >Update Payment</vs-button
            >
          </div>
        </div>
        <div class="vx-col lg:w-1/2 w-full" style="padding: 0 5px">
          <vx-card title="Collection Details">
            <vs-table :data="lrDetails.collections">
              <template slot="thead">
                <vs-th>Agent Name</vs-th>
                <vs-th>Sent Date</vs-th>
                <vs-th>Updated Date</vs-th>
                <vs-th>Status</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].collectionAgentName">
                    {{ data[indextr].collectionAgentName }}
                  </vs-td>
                  <vs-td :data="data[indextr].createdOn">
                    {{ data[indextr].createdOn | date(true) }} by
                    {{ data[indextr].collectionCreatedUser }}
                  </vs-td>
                  <vs-td :data="data[indextr].modifiedOn">
                    {{ data[indextr].modifiedOn | date(true) }} by
                    {{ data[indextr].collectionUpdatedUser }}
                  </vs-td>
                  <vs-td :data="data[indextr].collectionStatus">
                    <span v-if="data[indextr].collectionStatus == 1">
                      Sent for Collection
                    </span>
                    <span v-else-if="data[indextr].collectionStatus == 2">
                      Not Paid
                    </span>
                    <span v-else-if="data[indextr].collectionStatus == 3">
                      Not Paid Went for Another Collection
                    </span>
                    <span v-else-if="data[indextr].collectionStatus == 4">
                      Paid
                    </span>
                    <span v-else> -- </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </div>
      <div
        class="vx-row m-3"
        style="margin-bottom: 4rem !important; width: 100%"
      >
        <div class="vx-col w-full" style="padding: 0 5px">
          <vx-card title="Shipment Track">
            <div
              class="vx-row"
              v-if="lrDetails.consignmentTrips.length <= 0"
              style="float: right; margin-bottom: 3.8rem"
            >
              <div v-if="isShowTripControl">
                <vs-select
                  autocomplete
                  name="tripId"
                  v-model="lrDetails.tripId"
                  icon="arrow_downward"
                  width="100%"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.tripId"
                    :text="item.tripId"
                    v-for="(item, index) in trips"
                  />
                </vs-select>
              </div>
              <vs-button
                v-if="!isShowTripControl"
                @click="isShowTripControl = true"
                >Add Trip</vs-button
              >
            </div>

            <vs-table :data="lrDetails.consignmentTrips">
              <template slot="thead">
                <!-- <vs-th>Edit</vs-th> -->
                <vs-th>Trip Id</vs-th>

                <vs-th>Trip Location</vs-th>
                <vs-th>Intial Comment</vs-th>
                <vs-th>Final Comment</vs-th>
                <vs-th>Vehicle No</vs-th>
                <vs-th>Start Date</vs-th>
                <vs-th>Reached Date</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <!-- <vs-td :data="data[indextr].tripId">
                     <vs-button class="sm-icons-dg" icon-pack="feather" radius icon="icon-edit-2" @click="isUpdateTrip= true"></vs-button>
                  </vs-td> -->
                  <vs-td :data="data[indextr].tripId">
                    <!-- {{consignmentTripsId}} -->
                    <div>
                      {{ data[indextr].tripId }} /
                      {{ data[indextr].fromShortName }}
                    </div>
                    <!-- <div v-else-if="isUpdateTrip">
                      <vs-select
                      autocomplete
                      name="tripId"
                      v-model="data[indextr].tripId"
                      icon="arrow_downward"
                      width="100%"
                    >
                      <vs-select-item
                        :key="index"
                        :value="item.tripId"
                        :text="item.tripId"
                        v-for="(item, index) in trips"
                      />
                    </vs-select>
                    </div> -->
                  </vs-td>
                  <vs-td :data="data[indextr].fromBranchName">
                    {{ data[indextr].fromBranchName }} -
                    {{ data[indextr].toBranchName }}
                  </vs-td>
                  <vs-td :data="data[indextr].consignmentTripInitalComment">
                    {{ data[indextr].consignmentTripInitalComment }}
                  </vs-td>

                  <vs-td :data="data[indextr].consignmentTripFinalComment">
                    {{ data[indextr].consignmentTripFinalComment }}
                  </vs-td>

                  <vs-td :data="data[indextr].VehicleNo">
                    {{ data[indextr].VehicleNo }}
                  </vs-td>
                  <vs-td :data="data[indextr].tripStartedDate">
                    {{ data[indextr].tripStartedDate | date(true) }}
                  </vs-td>
                  <vs-td :data="data[indextr].tripReachedDate">
                    {{ data[indextr].tripReachedDate | date(true) }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
        <div class="vx-row" v-if="isShowTripControl" style="float: right">
          <vs-button icon-pack="material-icons" class="mt-4" @click="updateTrip"
            >Save Trip</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    getTotalPayment() {
      const sumAmount =
        parseInt(this.lrDetails.consignmentFreightCharge || 0) +
        parseInt(this.lrDetails.consignmentHamaliCharge || 0) +
        parseInt(this.lrDetails.consignmentStationaryCharge || 0) +
        parseInt(this.lrDetails.consignmentCollectionCharges || 0) +
        parseInt(this.lrDetails.consignmentDoorDeliveryCharge || 0) +
        parseInt(this.lrDetails.consignmentLrCopyCharge || 0) +
        parseInt(this.lrDetails.consignmentOtherCharge || 0) +
        parseInt(this.lrDetails.consignmentUnloadingCharge || 0);
      return sumAmount;
    }
  },
  data() {
    return {
      consignmentStatusList: [
        { name: "Booked", value: 1 },
        { name: "Binded to Vehicle", value: 2 },
        { name: "Unloaded and Waiting for Delivery", value: 3 },
        { name: "Waiting for Trans Shipment", value: 4 },
        { name: "Delivered", value: 5 }
      ],
      currentLrNo: null,
      consignementTypesList: [],
      editPackageDetails: {},
      loadingLrData: false,
      isShowEditConsignmentPackageDetails: false,
      isShowToBranchControl: false,
      isShowConsignmentStatusControl: false,
      isUpdateTrip: false,
      isShowTripControl: false,
      lrDetails: null,
      isShowUpdateConsignorDetails: false,
      lrDataFound: false,
      isShowCurrentBranchControl: false,
      isShowPaymentControls: false,
      isShowUpdateConsigneeDetails: false,
      fetchingLrDetails: false,
      toBranches: [],
      branches: [],
      trips: [],
      sessionRoleId: JSON.parse(localStorage.getItem("sstUnData")).roles[0]
        .roleId,
      branchId: JSON.parse(localStorage.getItem("sstUnData")).branchId,
      // pdfUrl: "http://localhost:8081/transport-System/PDF/views/new/",
      pdfUrl: "https://newpdf.srisainadhtransport.in/2025/"
    };
  },
  methods: {
    getBranches() {
      this.$http.get("common/branches").then(response => {
        this.branches = response.data.data;
        this.toBranches = this.branches;
        // .filter((branch) => {
        //   return branch.branchId != this.lrDetails.fromBranchId;
        // });
        // this.$vs.loading.close("#add-edit-branch-container > .con-vs-loading");
      });
    },
    getTrips() {
      this.$http.get("portage/memosall").then(response => {
        this.trips = response.data.data;
      });
    },
    getConsignementType() {
      this.$http.get(`common/consignmentTypes`).then(response => {
        this.consignementTypesList = response.data.data;
      });
    },
    setConsignmentPackageDetails(e) {
      this.isShowEditConsignmentPackageDetails = true;
      this.editPackageDetails = this.lrDetails.packages[e];
    },
    getClients() {
      this.getConsignementType();
      this.$http.get("portage/clients").then(response => {
        this.clients = response.data.data;
      });
    },

    showLr() {
      const url =
        this.pdfUrl +
        "lrview.php?lrno=" +
        btoa(this.lrDetails.consignmentLrNo) +
        "&token=" +
        localStorage.getItem("sessionToken");
      window.open(url, "_blank");
    },

    copyLr() {
      const thisIns = this;
      const lrData = this.lrDetails;
      let showedMessage = false;
      let copyString = `Lr No : ${lrData.consignmentLrNo}\nFrom: ${lrData.consignmentFromBranchName}\nTo: ${lrData.consignmentToBranchName}\nStatus: *${lrData.consignmentStatusName}*\nConsignor:${lrData.consignor.consignmentConsignorName} ${lrData.consignor.consignmentConsignorMobileNo}\nConsignee: ${lrData.consignee.consignmentConsigneeName} ${lrData.consignee.consignmentConsigneeMobileNo}\nQuantity:${lrData.consignmentPackagesTotalCnt}`;
      copyString = copyString.toString();
      this.$copyText(copyString).then(function() {
        if (!showedMessage) {
          showedMessage = true;
          thisIns.$vs.notify({
            title: "Success",
            text: "LR Data Copied Successfully",
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle"
          });
        }
      });
    },
    showFreight() {
      if (this.lrDetails.consignmentFreightNo) {
        //code
        const url =
          this.pdfUrl +
          "freightreceiptpdf.php?lrno=" +
          btoa(this.lrDetails.consignmentId) +
          "&token=" +
          localStorage.getItem("sessionToken");
        window.open(url, "_blank");
      } else {
        this.$vs.notify({
          title: "Freight was not generated!Please try lateral",
          color: "danger",
          position: "top-right"
        });
      }
    },
    getLrDetails(_e) {
      this.fetchingLrDetails = true;
      if (
        this.currentLrNo == 0 ||
        this.currentLrNo == "" ||
        this.currentLrNo == null
      ) {
        this.$vs.notify({
          title: `Please Enter LR NO`,
          color: "danger",
          position: "top-right"
        });
      } else {
        this.lrDetailsServiceRequest(this.currentLrNo);
        this.getBranches();
        this.getTrips();
        this.getClients();
      }
    },
    updateActivePackageDetails() {
      const obj = this.editPackageDetails;
      this.$http
        .put(`portage/updatepackage`, obj)
        .then(_response => {
          (this.isShowEditConsignmentPackageDetails = false),
            (this.editPackageDetails = {});
          this.lrDetailsServiceRequest(this.lrDetails.consignmentLrNo);
        })
        .catch(error => {
          (this.isShowEditConsignmentPackageDetails = false),
            (this.editPackageDetails = {});
          this.$vs.notify({
            title: error.response.data.message,
            color: "danger",
            position: "top-right"
          });
        });
    },
    updatePayment() {
      // console.log("Test");
      const obj = {
        consignmentFreightCharge: this.lrDetails.consignmentFreightCharge || 0,
        consignmentHamaliCharge: this.lrDetails.consignmentHamaliCharge || 0,
        consignmentStationaryCharge:
          this.lrDetails.consignmentStationaryCharge || 0,
        consignmentCollectionCharges:
          this.lrDetails.consignmentCollectionCharges || 0,
        consignmentDoorDeliveryCharge:
          this.lrDetails.consignmentDoorDeliveryCharge || 0,
        consignmentLrCopyCharge: this.lrDetails.consignmentLrCopyCharge || 0,
        consignmentUnloadingCharge:
          this.lrDetails.consignmentUnloadingCharge || 0,
        consignmentOtherCharge: this.lrDetails.consignmentOtherCharge || 0
      };
      this.$http
        .post(`portage/updatepayment/${this.lrDetails.consignmentLrNo}`, obj)
        .then(_response => {
          if (_response.message == "Consignment has no freight No") {
            this.$vs.notify({
              title: _response.message,
              color: "danger",
              position: "top-right"
            });
          }
          this.lrDetailsServiceRequest(this.lrDetails.consignmentLrNo);
        })
        .catch(error => {
          this.$vs.notify({
            title: error.response.data.message,
            color: "danger",
            position: "top-right"
          });
        });
    },
    updateDetails() {
      const obj = {
        currentBranchId: this.lrDetails.currentBranchId,
        consignmentStatus: this.lrDetails.consignmentStatus,
        toBranchId: this.lrDetails.toBranchId
      };
      this.$http
        .post(
          `portage/updatebasicdetails/${this.lrDetails.consignmentLrNo}`,
          obj
        )
        .then(_response => {
          this.lrDetailsServiceRequest(this.lrDetails.consignmentLrNo);
        })
        .catch(error => {
          this.$vs.notify({
            title: error.response.data.message,
            color: "danger",
            position: "top-right"
          });
        });
      console.log("updateDetails", obj);
    },
    updateConsignor() {
      const obj = {
        consignorId: this.lrDetails.consignorId
      };
      this.$http
        .post(`portage/updateconsignor/${this.lrDetails.consignmentLrNo}`, obj)
        .then(_response => {
          this.lrDetailsServiceRequest(this.lrDetails.consignmentLrNo);
        })
        .catch(error => {
          this.$vs.notify({
            title: error.response.data.message,
            color: "danger",
            position: "top-right"
          });
        });
      // console.log("updateConsignor");
    },
    updateConsignee() {
      const obj = {
        consigneeId: this.lrDetails.consigneeId
      };
      this.$http
        .post(`portage/updateconsignee/${this.lrDetails.consignmentLrNo}`, obj)
        .then(_response => {
          this.lrDetailsServiceRequest(this.lrDetails.consignmentLrNo);
        })
        .catch(error => {
          this.$vs.notify({
            title: error.response.data.message,
            color: "danger",
            position: "top-right"
          });
        });
      console.log("updateConsignee");
    },
    updateTrip() {
      // if(this.lrDetails.consignmentTrips.length<=0){
      const tripDetails = this.trips.find(
        data => data.tripId === +this.lrDetails.tripId
      );
      const obj = {
        tripId: this.lrDetails.tripId,
        tripUniq: tripDetails.tripUniq,
        consignmentId: this.lrDetails.consignmentId
      };
      this.$http
        .post(`portage/addtrip/${this.lrDetails.consignmentLrNo}`, obj)
        .then(_response => {
          this.lrDetailsServiceRequest(this.lrDetails.consignmentLrNo);
        })
        .catch(error => {
          this.$vs.notify({
            title: error.response.data.message,
            color: "danger",
            position: "top-right"
          });
        });
      // console.log("UpdateTrips");
      // }
      // else{

      // }
    },
    lrDetailsServiceRequest(lrNo) {
      this.$http
        .get(`portage/lrsearch/${lrNo}`)
        .then(response => {
          this.lrDetails = response.data.data;
          // console.log(response);
          this.searchedLr = true;
          this.lrDataFound = true;
          false;
          this.isShowConsignmentStatusControl = false;
          this.isUpdateTrip = false;
          this.isShowTripControl = false;
          this.isShowUpdateConsignorDetails = false;
          this.isShowCurrentBranchControl = false;
          this.isShowPaymentControls = false;
          this.isShowUpdateConsigneeDetails = false;
          this.fetchingLrDetails = false;
        })
        .catch(error => {
          this.$vs.notify({
            title: error.response.data.message,
            color: "danger",
            position: "top-right"
          });
        });
    }
  }
};
</script>
<style scoped>
.sm-icons-dg {
  width: 24px !important;
  height: 24px !important;
}
.xsm-icons-dg {
  width: 12px !important;
  height: 12px !important;
  padding: 9px !important;
}
</style>
